// Hide and show header based on scroll
export function siteheaderScroll() {
    const navbar = document.querySelector('#site-header');
    if (!navbar) return;

    let lastScrollTop = 0;
    const delta = 5;
    const navbarHeight = navbar.offsetHeight;

    // Throttle scroll handling to improve performance
    let throttleTimer;
    window.addEventListener('scroll', () => {
        if (!throttleTimer) {
            throttleTimer = setTimeout(() => {
                handleScroll();
                throttleTimer = null;
            }, 250);
        }
    });

    // Handle header visibility based on scroll position
    function handleScroll() {
        const scrollTop = window.scrollY;

        if (Math.abs(lastScrollTop - scrollTop) <= delta) return;

        if (scrollTop > lastScrollTop && scrollTop > navbarHeight) {
            // Scrolling Down
            navbar.classList.add('nav-up');
            navbar.classList.remove('nav-down');
        } else if (scrollTop + window.innerHeight < document.body.clientHeight) {
            // Scrolling Up
            navbar.classList.add('nav-down');
            navbar.classList.remove('nav-up');
        }

        lastScrollTop = scrollTop;
    }

    // Add 'scrolled' class when header crosses a certain point
    const addScrolledClass = () => {
        const top = window.scrollY || document.documentElement.scrollTop;
        navbar.classList.toggle('scrolled', top > navbarHeight);
    };

    window.addEventListener('scroll', addScrolledClass);
    window.addEventListener('load', addScrolledClass);
}
